module.exports = __webpack_public_path__ + "img/MiddleSide_Left.cb716b99.jpg";